import React, { useState, useEffect, useRef } from 'react';
import '../component.scss';
import SearchField from './SearchField';
import SearchRegionsDropdownList from './SearchRegionsDropdownList';
import { AiOutlineMinusCircle, AiOutlinePlusCircle } from 'react-icons/ai';

const SearchRegionsWidget = ({
  value,
  subvalue = [],
  dictionary = {},
  items,
  label,
  title = '',
  width = 220,
  placeholder = true,
  buttonDone = true,
  buttonReset = false,
  type = 'base',
  onChoose,
  onSubChoose,
  cssClass = '',
  isChanged = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [wasChanged, setWasChanged] = useState(false);
  const [openGroup, setOpenGroup] = useState(null);

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
      if (e.key === 'Escape') {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleClickOutside);
    };
  }, []);

  const setValue = (val, sub = false) => {
    if (sub) {
      onSubChoose(sub);
    } else {
      onChoose(val);
    }
  };

  useEffect(() => {
    if (value.length > 0 || subvalue.length > 0) {
      setWasChanged(true);
    } else setWasChanged(false);
  }, [value, subvalue]);

  const reset = () => {
    setValue([]);
    setIsOpen(false);
  };

  const handleGroupToggle = (groupName) => {
    setOpenGroup((prevOpenGroup) =>
      prevOpenGroup === groupName ? null : groupName
    );
  };

  return (
    <div ref={dropdownRef} className={`search-widget ${cssClass}`}>
      {!isOpen ? (
        <>
          <div
            onClick={() => setIsOpen(!isOpen)}
            className={`search-field ${wasChanged}`}
          >
            <SearchField
              cssClass={cssClass}
              placeholder={placeholder}
              label={label}
              title={title}
              value={value}
              dictionary={dictionary}
            />
          </div>
        </>
      ) : (
        <>
          <SearchField
            label={label}
            title={title}
            value={value}
            dictionary={dictionary}
          />
          <div className="popup-list" style={{ width: width }}>
            <div className="filterbar">
              {buttonDone && (
                <button
                  className="btn btn_submit"
                  onClick={() => setIsOpen(false)}
                >
                  Готово
                </button>
              )}
              {buttonReset && (
                <button className="btn btn_reset" onClick={reset}>
                  Сбросить
                </button>
              )}
            </div>

            <div className="popup-body fixed">
              <div className="popup-body__items">
                {items.map((item) => {
                  if (item.children) {
                    const { children, group, id } = item;

                    let isAnyItemChosen = children.some((child) =>
                      value.includes(child.id)
                    );

                    let isAnySubItemChosen = children.some(
                      (child) =>
                        child.subitems &&
                        child.subitems.some((subitem) =>
                          subvalue.includes(subitem.id)
                        )
                    );

                    const isChosen = isAnyItemChosen || isAnySubItemChosen;
                    return (
                      <div className="group" key={id}>
                        <div
                          className={`group__title group__title_grand ${
                            isChosen ? 'group__title_chosen' : ''
                          }`}
                          onClick={() => handleGroupToggle(group)}
                        >
                          <p style={{ margin: 0 }}>{group}</p>
                          <button>
                            {openGroup === group ? (
                              <AiOutlineMinusCircle color="#fb089b" />
                            ) : (
                              <AiOutlinePlusCircle />
                            )}
                          </button>
                        </div>
                        <div
                          className={`group__items ${
                            openGroup === group ? 'group__items_opened' : ''
                          }`}
                        >
                          {children.map((child) => {
                            return (
                              <div
                                className="group"
                                key={child.id}
                                onClick={() => onChoose(child.id)}
                              >
                                <SearchRegionsDropdownList
                                  value={value}
                                  subvalue={subvalue}
                                  onChoose={setValue}
                                  item={child}
                                  titleCss={' group__title_subcolor'}
                                />
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    );
                  } else {
                    return (
                      <div
                        className="group"
                        key={item.id}
                        onClick={() => onChoose(item.id)}
                      >
                        <SearchRegionsDropdownList
                          value={value}
                          subvalue={subvalue}
                          onChoose={setValue}
                          item={item}
                        />
                      </div>
                    );
                  }
                })}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SearchRegionsWidget;
